import React from 'react';
import { messages } from '../../common/messages';

export default class NotesStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isNotesRead: false,
    };
  }

  async componentDidMount() {
    const { apiServiceProvider, id, level } = this.props;
    const result = await apiServiceProvider['fetchNotesStats']({ id, level });
    if (result.success) {
      this.setState({ isNotesRead: true });
    } else {
      setTimeout(() => {
        this.onHandleStats();
      }, 3000);
    }
  }
  async componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.setState({ isNotesRead: false });
      const { apiServiceProvider, id, level } = this.props;
      const result = await apiServiceProvider['fetchNotesStats']({ id, level });
      if (result.success) {
        this.setState({ isNotesRead: true });
      } else {
        setTimeout(() => {
          this.onHandleStats();
        }, 3000);
      }
    }
  }
  onHandleStats = async () => {
    const { isNotesRead } = this.state;
    if (!isNotesRead) {
      const { apiServiceProvider, id, level } = this.props;
      const result = await apiServiceProvider['saveNotesStats']({ id, level });
      if (result.success) {
        this.setState({ isNotesRead: true });
      }
    }
  };
  render() {
    const { isNotesRead } = this.state;
    return (
      <span className='up tooltip-hover-questions '>
        <div className='tootip_box'>
          {isNotesRead ? messages.UNREAD_NOTES : messages.READ_NOTES}{' '}
        </div>
        <i
          onClick={() => this.onHandleStats}
          className='fa fa-check mark-action-btn'
          aria-hidden='true'
          style={{ backgroundColor: isNotesRead ? 'green' : 'rgb(221, 221, 221)' }}
        />
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/Notes/NotesStats.jsx